import { render, staticRenderFns } from "./table-group.vue?vue&type=template&id=6734cf02&scoped=true"
import script from "./table-group.vue?vue&type=script&lang=js"
export * from "./table-group.vue?vue&type=script&lang=js"
import style0 from "./table-group.vue?vue&type=style&index=0&id=6734cf02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6734cf02",
  null
  
)

export default component.exports